<template>
  <MgdFormLabel
    class="flex-wrap items-baseline"
    :class="{ 'sr-only': hideLabel }"
    :disabled="disabled"
  >
    {{ label }}
    <div v-if="required" class="text-xs font-normal">Required</div>
  </MgdFormLabel>
</template>

<script lang="ts">
export function useFormFieldLabelProps(
  props: FormFieldLabelProps,
): Ref<FormFieldLabelProps> {
  return toRef({
    name: props.name,
    label: props.label,
    hideLabel: props.hideLabel,
    disabled: props.disabled,
  });
}
</script>

<script setup lang="ts">
export interface FormFieldLabelProps {
  name: string;
  label: string;
  hideLabel?: boolean;
  disabled?: boolean;
}

defineProps<FormFieldLabelProps & { required: boolean }>();
</script>
